import React from 'react';
import { FileText, Settings, Info, DollarSign, Calendar, Shield, StickyNote } from 'lucide-react';

const VARIANTS = {
  general: { Icon: FileText, tone: 'text-blue-400' },
  config: { Icon: Settings, tone: 'text-green-400' },
  details: { Icon: Info, tone: 'text-purple-400' },
  financial: { Icon: DollarSign, tone: 'text-emerald-400' },
  calendar: { Icon: Calendar, tone: 'text-amber-400' },
  security: { Icon: Shield, tone: 'text-red-400' },
  /** Notes / mémo — distinct from `config` (gear green) and `financial` (emerald) */
  notes: { Icon: StickyNote, tone: 'text-orange-400' },
};

/**
 * Icon + section title row for glass modal accordions.
 * Typography matches Inventaire `WarehousesPage` (e.g. « Informations Entrepôt »):
 * `text-lg font-semibold`, `gap-3`, Lucide icons at 20px (`h-5 w-5`).
 * Always use Lucide here — do not pass Heroicons (they ignore `size` and look wrong).
 */
function ModalAccordionSectionTitle({ variant = 'general', children }) {
  const { Icon, tone } = VARIANTS[variant] ?? VARIANTS.general;

  return (
    <div className="flex items-center gap-3 min-w-0">
      <Icon className={`h-5 w-5 flex-shrink-0 ${tone}`} aria-hidden />
      <h3 className="m-0 text-lg font-semibold text-white">{children}</h3>
    </div>
  );
}

export default ModalAccordionSectionTitle;

